/* eslint-disable camelcase */
import { useTranslation } from '@sailor/i18n-web'
import React, { useEffect, useMemo, useRef, useState, FC, PropsWithChildren } from 'react'
import Layout from '@roo/roo-plus/Layout'
import Menu, { MenuItem } from '@roo/roo-plus/Menu'
import { Badge } from '@roo/roo'
import { useNavigate, useLocation } from 'react-router-dom'
import styles from './index.module.less'
import LangeSelector from '../LangSelector'
import { loginUserInfo } from '@/common/recoil/atom/userAtom'
import { useRecoilValue } from 'recoil'
import LoginUserInfo from './LoginUserInfo'
import { isEn } from '@/common/utils/i18nFuncs'
import entInfoAtom from '@/common/recoil/atom/entInfoAtom'
import aggregateQueryAtom from '@/common/recoil/atom/aggregateQuery'

const { Aside: Sider } = Layout
const side_bg = 'https://img-ap-hongkong.mykeeta.net/sailorfebpcassets/side_menu_bg.png'
const logo = 'https://img-ap-hongkong.mykeeta.net/sailorcweb/ac79ab04bd38d87c2ba4006fe4c081c417269.png'


interface MenuItem {
  key: string;
  i18nKey: string;
  label: string;
  menuURL?: string;
  isOutside?: boolean;
  children?: MenuItem[];
  showBadge?: boolean;  // 是否显示红点角标
}


const SideMenu:FC<PropsWithChildren> = () =>  {
  const hashLocation = useLocation()
  const entInfo = entInfoAtom.useData()
  const aggregateQueryInfo = aggregateQueryAtom.useData()
  const userInfo = useRecoilValue(loginUserInfo)
  const menuCollapsed: boolean = sessionStorage.getItem('MENU_COLLAPSED') === 'true'
  const [openKeys, setOpenKeys] = useState<any>([])
  const [collapsed, setCollapsed] = useState(menuCollapsed)
  const wrapperRef = useRef<HTMLDivElement>(null)
  const hasScroll = useRef<boolean>(false)
  const navigate = useNavigate()
  const { t } = useTranslation()


  const isLogin = Boolean(userInfo.entName || userInfo.entAdminName)
  const inLoginPage =  ['/login', '/password/forget'].includes(hashLocation.pathname)

  const showMenu = [
    {
      i18nKey: 'e_pc_home_page',
      label: '首页',
      menuURL: '/',
    },
    {
      i18nKey: 'e_pc_enterprise_mgmt',
      label: '企业管理',
      menuURL: '/enterprise',
    },
    {
      i18nKey: 'e_pc_rule_management',
      label: '规则管理',
      menuURL: '/rule',
    },
    {
      i18nKey: 'e_pc_order_query',
      label: '订单查询',
      menuURL: '/order',
    },
    {
      i18nKey: 'Keeta_EE_Financial_management_67HA', // 原 e_pc_bill_management
      label: '财务管理',  // 原 账单管理
      menuURL: '/bill',
      showBadge: aggregateQueryInfo?.financialBadge,  // 显示红点角标
    },
    entInfo?.useWalletAsset &&
    {
      i18nKey: 'batch_management',
      label: '批次管理',
      menuURL: '/batch',
    },
  ].filter(item => item)


  const selectedKeys = useMemo(() => ([`/${[hashLocation.pathname?.split('/')[1]]}`]), [hashLocation])


  const handleRooMenuSelected = (target: string) => {
    navigate(target)
  }
  const onRooOpenChange: any = (key: string | number) => {
    setOpenKeys([key])
  }

  const setHasScroll = () => {
    hasScroll.current = true
  }


  useEffect(() => {
    const { current } = wrapperRef
    current?.addEventListener('scroll', setHasScroll)
    return () => {
      current?.removeEventListener('scroll', setHasScroll)
    }
  }, [])


  return (
    <div
      className={styles.left}
      ref={wrapperRef}
      style={{
        width: collapsed ? '80px' : '256px',
        minWidth: collapsed ? '80px' : '256px',
      }}
    >
      <div  className={styles.menu_header}>
        <span style={{ fontSize: isEn() ? '12px' : '16px', fontWeight: 600, color: '#5e521a' }}></span>
        <LangeSelector/>
      </div>
      <div className={styles.leftContent}>
        <img src={logo} alt="" width="100%" style={{ position: 'absolute', top: '48px', width: '100%', left: 0 }} />
        <Sider className={collapsed ? styles.siderCollapsed : styles.siderExterned} style={{ width: '256px', background: 'unset' }}>
          <div className={styles.asideChildren}>
            {
              isLogin && (
                <Menu
                  className={styles.menu}
                  theme={'light'}
                  openedIds={openKeys}
                  defaultOpenedIds={openKeys}
                  selectedIds={selectedKeys}
                  collapsed={collapsed}
                  // onClick={handleRooMenuSelected}
                  onOpenChange={onRooOpenChange}
                >
                  {showMenu.map(menu => (
                    <MenuItem key={menu.menuURL} id={menu.menuURL} onClick={() => handleRooMenuSelected(menu.menuURL)}>
                      <Badge dot={menu.showBadge} offset={[6, 0]}>
                        <span>{t(menu?.i18nKey, menu.label)}</span>
                      </Badge>
                    </MenuItem>
                  )
                  )}
                </Menu>
              )
            }
          </div>
        </Sider>
        {!inLoginPage && <LoginUserInfo />}
        <img src={side_bg} alt="" width="100%" style={{ position: 'absolute', bottom: 0 }} />
      </div>
    </div>
  )
}

export default SideMenu